import React, { useContext, useState } from "react";
import "./test.css";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../AuthContext";
import axios from "axios";

const questions = [
  "Are you feeling nervous?",
  "Do you often get panic attacks?",
  "Are you breathing rapidly?",
  "Are you sweating often?",
  "Do you have trouble concentrating?",
  "Do you have trouble sleeping?",
  "Do you have trouble with work?",
  "Are you feeling hopeless?",
  "Are you angry?",
  "Has anyone said that you might be overreacting?",
  "Have you changed the types of food you eat recently?",
  "Have you ever thought about suicide?",
  "Are you feeling tired?",
  "Do you have any close friends?",
  "Are you addicted to social media?",
  "Have you gained weight lately?",
  "Are you introverted?",
  "Do stressful memories pop up often?",
  "Are you having nightmares?",
  "Are you avoiding people or activities?",
  "Do you feel negative?",
  "Do you have trouble concentrating?",
  "Do you blame yourself?",
  "Do you have hallucinations?",
  "Do you have any depression at your work?",
  "Do you have repetitive behavior?",
  "Do you feel worse seasonally?",
  "Do you have increased energy?",
];

const TestQuestion = () => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [showingAnswers, setShowingAnswers] = useState([]);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false); 
  const navigate = useNavigate();
  const persanage = useContext(AuthContext);

  const handleQuestionIndex = async (answer) => {
    setSelectedAnswer(answer);
    const newAnswers = [...answers, answer];
    const newShowingAnswers = [
      ...showingAnswers,
      { question: questions[currentQuestionIndex], answer },
    ];

    setAnswers(newAnswers);
    setShowingAnswers(newShowingAnswers);

    if (currentQuestionIndex < questions.length - 1) {
      setTimeout(() => {
        setCurrentQuestionIndex(currentQuestionIndex + 1);
        setSelectedAnswer(null);
      }, 50);
    } else {
      const binaryAnswers = newAnswers.map((answer) =>
        answer === "Yes" ? 1 : 0
      );
      persanage.setPersantage(binaryAnswers);
      const formattedAnswers = { answers: binaryAnswers };
      persanage.setQuestionsAnswers(showingAnswers);

      setIsLoading(true); 

      try {
        const response = await axios.post(
          "https://sentment-analysis.onrender.com/predict-mental-health",
          formattedAnswers
        );

        if (response.status === 200) {
          console.log("Data sent successfully");
          console.log(response.data);
          persanage.setResult(response.data);
        } else {
          console.error("Failed to send data");
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setIsLoading(false); 
        setShowModal(true);
      }
    }
  };

  const handleBack = () => {
    if (currentQuestionIndex > 0) {
      const newAnswers = answers.slice(0, -1);
      const newShowingAnswers = showingAnswers.slice(0, -1);

      setCurrentQuestionIndex(currentQuestionIndex - 1);
      setAnswers(newAnswers);
      setShowingAnswers(newShowingAnswers);
      setSelectedAnswer(null);
    }
  };

  const progressPercentage =
    ((currentQuestionIndex + 1) / questions.length) * 100;

  const handleClose = () => {
    setShowModal(false);
    navigate("/result");
  };

  return (
    <div id="testquestion" className="container">
    
        <div className="d-flex justify-content-center flex-column w-100 mx-auto align-items-center mt-5 mb-5  py-4 ">
          <div className="test-msg position-relative">
            <div className="top-layer d-flex flex-row justify-content-between align-items-center px-4 position-absolute">
              <span className="">
                {currentQuestionIndex + 1} of {questions.length}
              </span>
              <div
                style={{
                  height: "20px",
                  width: "60%",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "10px",
                  overflow: "hidden",
                }}
                className="progress-bar-container"
              >
                <div
                  style={{
                    height: "100%",
                    width: `${progressPercentage}%`,
                    backgroundColor: "#007bff",
                    transition: "width 0.5s",
                  }}
                  className="progress-bar"
                ></div>
              </div>
              <button
                className="border-0 bg-transparent"
                onClick={handleBack}
                disabled={currentQuestionIndex === 0}
              >
                Back
              </button>
            </div>

            <div className=" test-msg-content text-center  px-5 w-100 py-5 mt-5 ">
              <p className="fs-4 text-center px-4 w-100 mt-5">
                {questions[currentQuestionIndex]}
              </p>

              <div className="d-flex align-items-center mt-5 justify-content-between gap-5">
                <div
                  className={` ${
                    selectedAnswer === "Yes"
                      ? "selected border rounded-pill border-primary btn px-4 mt-3"
                      : "btn px-4 mt-3 test-btn"
                  }`}
                  onClick={() => handleQuestionIndex("Yes")}
                >
                  Yes
                </div>

                <div
                  className={` ${
                    selectedAnswer === "No"
                      ? "selected border border-primary rounded-pill btn px-4 mt-3"
                      : "btn px-4 mt-3 test-btn"
                  }`}
                  onClick={() => handleQuestionIndex("No")}
                >
                  No
                </div>
              </div>
            </div>
          </div>
        </div>

      {isLoading && (
        <div className="loader-container d-flex justify-content-center align-items-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )}

      {showModal && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header d-flex justify-content-between align-items-center">
                <h5 className="modal-title">Test Completed</h5>
                <button
                  type="button"
                  className="close btn btn-danger text-white py-1 px-2"
                  onClick={handleClose}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                You have completed the test. Click OK to see your results.
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleClose}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TestQuestion;
